/**
 * A mastery bar, 0-100. The value is the scheduler's own estimate of how long
 * you would still remember the material, so the bar means something concrete
 * rather than "moves seen".
 */
export default function MasteryBar({
  value,
  label,
  compact = false,
}: {
  value: number;
  label?: string;
  compact?: boolean;
}) {
  const pct = Math.max(0, Math.min(100, Math.round(value)));
  // Red until it is genuinely learned, amber while it is settling, green once
  // the interval is long enough to call it known.
  const tone = pct >= 80 ? 'good' : pct >= 35 ? 'mid' : 'low';

  return (
    <div className={`mastery${compact ? ' mastery--compact' : ''}`}>
      {label && <span className="mastery-label">{label}</span>}
      <div
        className="mastery-track"
        role="progressbar"
        aria-valuenow={pct}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={label ?? 'Mastery'}
      >
        <div className={`mastery-fill mastery-fill--${tone}`} style={{ width: `${pct}%` }} />
      </div>
      <span className="mastery-value">{pct}%</span>
    </div>
  );
}
